import api from '../lib/api';
import { handle401 } from './error-handlers';

export const SUBMIT_PAYMENT = 'SUBMIT_PAYMENT';

export const REQUEST_NOTIFY_FAILED_MEMBERSHIPS = 'REQUEST_NOTIFY_FAILED_MEMBERSHIPS';
export const NOTIFY_FAILED_MEMBERSHIPS = 'NOTIFY_FAILED_MEMBERSHIPS';

export const submitPayment = (paymentId, authentication) => {
  return dispatch => (
    api.post(`/payments/${paymentId}/submit`, {}, {
      authorization: { bearer: authentication.token },
    })
    .then(() => dispatch({ type: SUBMIT_PAYMENT }))
    .catch(handle401(dispatch))
  );
};

export function notifyFailedMemberships(paymentId, authentication) {
  return (dispatch) => {
    dispatch({ type: REQUEST_NOTIFY_FAILED_MEMBERSHIPS });
    return api.post(`/payments/${paymentId}/notifications/failures`, {}, {
      authorization: { bearer: authentication.token },
    })
    .then(() => dispatch({ type: NOTIFY_FAILED_MEMBERSHIPS, payload: {} }))
    .catch(handle401(dispatch));
  };
}



// WEBPACK FOOTER //
// ./src/actions/payments.js